import styled from 'styled-components';

export const PageWrapper = styled.div`
  background: #1A1814;
  min-height: 100vh;
  padding-top: 88px;
`;

const Wrap = styled.div`
  max-width: 1440px;
  margin: 0 auto;
  padding-inline: clamp(20px, 4.5vw, 64px);
`;

export const ContactContainer = styled(Wrap)`
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
  gap: clamp(60px, 8vw, 120px);
  padding-block: clamp(60px, 10vh, 120px);
  align-items: center;

  @media (max-width: 968px) {
    grid-template-columns: 1fr;
    gap: 48px;
  }
`;

export const LeftSection = styled.div``;

export const Eyebrow = styled.span`
  display: block;
  font-family: 'IBM Plex Mono', ui-monospace, Menlo, monospace;
  font-size: 12px;
  font-weight: 500;
  letter-spacing: 0.22em;
  text-transform: uppercase;
  color: #D9442B;
  margin-bottom: 20px;
`;

export const Heading = styled.h1`
  font-family: 'Instrument Serif', Georgia, 'Times New Roman', serif;
  font-size: clamp(52px, 6vw, 72px);
  font-weight: 400;
  line-height: 0.95;
  margin: 0 0 24px;
  letter-spacing: -0.02em;
  color: #F3ECE1;

  em {
    font-style: italic;
    color: #D9442B;
  }

  @media (max-width: 768px) {
    font-size: 48px;
    line-height: 1;
  }
`;

export const Subtitle = styled.p`
  font-family: 'Newsreader', Georgia, serif;
  font-size: 19px;
  color: #BDB3A3;
  line-height: 1.55;
  margin: 0 0 48px;
  max-width: 30em;

  @media (max-width: 768px) {
    font-size: 17px;
  }
`;

export const EmailLink = styled.a`
  display: inline-block;
  font-family: 'Instrument Serif', Georgia, 'Times New Roman', serif;
  font-size: clamp(26px, 3.2vw, 38px);
  font-weight: 400;
  color: #F3ECE1;
  text-decoration: none;
  border-bottom: 2px solid #D9442B;
  padding-bottom: 4px;
  margin-bottom: 24px;
  transition: color 0.2s ease;

  &:hover {
    color: #D9442B;
  }

  &:focus-visible {
    outline: 2px solid #D9442B;
    outline-offset: 3px;
  }
`;

export const OrText = styled.p`
  font-family: 'IBM Plex Mono', ui-monospace, Menlo, monospace;
  font-size: 11px;
  font-weight: 400;
  letter-spacing: 0.16em;
  text-transform: uppercase;
  color: #D9442B;
  margin: 28px 0 0;
  cursor: pointer;
  transition: opacity 0.2s ease;
  display: block;
  width: fit-content;

  &:hover {
    opacity: 0.8;
  }

  &:focus-visible {
    outline: 2px solid #D9442B;
    outline-offset: 3px;
  }
`;

export const RightSection = styled.div``;

export const FormContainer = styled.form`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

export const FormRow = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 20px;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

export const InputGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const Label = styled.label`
  font-family: 'IBM Plex Mono', ui-monospace, Menlo, monospace;
  font-size: 11px;
  font-weight: 400;
  letter-spacing: 0.16em;
  text-transform: uppercase;
  color: #BDB3A3;
`;

export const Input = styled.input`
  width: 100%;
  height: 48px;
  background: #0F0E0C;
  border: none;
  border-bottom: 1px solid #3A342C;
  padding: 12px 16px;
  font-family: 'IBM Plex Sans', 'Helvetica Neue', Arial, sans-serif;
  font-size: 16px;
  color: #F3ECE1;
  transition: border-color 0.2s ease;
  box-sizing: border-box;

  &::placeholder {
    color: #6B645A;
  }

  &:focus {
    outline: none;
    border-bottom-color: #D9442B;
  }
`;

export const Select = styled.select`
  width: 100%;
  height: 48px;
  background-color: #0F0E0C;
  border: none;
  border-bottom: 1px solid #3A342C;
  padding: 12px 16px;
  font-family: 'IBM Plex Sans', 'Helvetica Neue', Arial, sans-serif;
  font-size: 16px;
  color: #F3ECE1;
  cursor: pointer;
  transition: border-color 0.2s ease;
  appearance: none;
  box-sizing: border-box;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none' stroke='%23F3ECE1' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpolyline points='6 9 12 15 18 9'%3E%3C/polyline%3E%3C/svg%3E");
  background-repeat: no-repeat;
  background-position: right 16px center;
  background-size: 20px;

  option {
    background: #0F0E0C;
    color: #F3ECE1;
  }

  &:focus {
    outline: none;
    border-bottom-color: #D9442B;
  }

  /* Change color when an option is selected */
  &:not(:invalid) {
    color: #F3ECE1;
  }

  /* Style for the placeholder option */
  option[value=""] {
    color: #6B645A;
  }
`;

export const TextArea = styled.textarea`
  width: 100%;
  min-height: 120px;
  background: #0F0E0C;
  border: none;
  border-bottom: 1px solid #3A342C;
  padding: 12px 16px;
  font-family: 'IBM Plex Sans', 'Helvetica Neue', Arial, sans-serif;
  font-size: 16px;
  color: #F3ECE1;
  resize: vertical;
  transition: border-color 0.2s ease;
  box-sizing: border-box;

  &::placeholder {
    color: #6B645A;
  }

  &:focus {
    outline: none;
    border-bottom-color: #D9442B;
  }
`;

interface SubmitButtonProps {
  isDisabled?: boolean;
}

export const SubmitButton = styled.button<SubmitButtonProps>`
  width: fit-content;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  padding: 17px 26px;
  background: #F3ECE1;
  color: #1A1814;
  font-family: 'IBM Plex Sans', 'Helvetica Neue', Arial, sans-serif;
  font-size: 15px;
  font-weight: 500;
  letter-spacing: 0.01em;
  border: none;
  cursor: ${props => props.isDisabled ? 'not-allowed' : 'pointer'};
  opacity: ${props => props.isDisabled ? 0.5 : 1};
  transition: gap 0.2s ease, opacity 0.2s ease;
  margin-top: 12px;

  &:hover {
    gap: ${props => props.isDisabled ? '12px' : '18px'};
  }

  &:focus-visible {
    outline: 2px solid #D9442B;
    outline-offset: 3px;
  }

  @media (max-width: 768px) {
    width: 100%;
  }

  @media (prefers-reduced-motion: reduce) {
    transition: none;
  }
`;

export const ButtonArrow = styled.span`
  color: #D9442B;
`;

export const SmallText = styled.p`
  font-family: 'Newsreader', Georgia, serif;
  font-size: 14px;
  color: #8A8276;
  margin: 8px 0 0;
  line-height: 1.6;
`;

// Legacy exports for compatibility
export const GradientOrb = styled.div``;
export const GradientOrbSecond = styled.div``;
export const ContactTag = styled.div``;
export const Title = styled.div``;
export const InputWrapper = styled.div``;
export const InputIcon = styled.div``;
export const ContactMethods = styled.div``;
export const ContactMethod = styled.div``;
export const Separator = styled.div``;
export const CardContainer = styled.div``;
export const LinkCard = styled.div``;
export const IconWrapper = styled.div``;
export const Icon = styled.div``;
export const TextWrapper = styled.div``;
export const LinkTitle = styled.div``;
export const LinkDescription = styled.div``;
export const FooterText = styled.div``;
export const ContentContainer = styled.div``;
